export class OTA_RateDistance {
    public unlimited: boolean;
    public quantity: number;
    public distUnitName: string;
    public vehiclePeriodUnitName: string;
}